export default __webpack_public_path__ + "static/media/swedgo-screenshot-03.a7576ec8.png";